<template>
  <Form
    class="form-container"
    :class="{ inline }"
    v-slot="{ errors, meta, isSubmitting, setFieldError }"
    @submit="
      async (values, { resetForm }) => {
        await callback();
        if (clean) resetForm();
      }
    "
  >
    <slot name="form-body" :errors="errors" :setFieldError="setFieldError"></slot>
    <slot v-if="displaySlotError" name="form-error" :errors="errors">
      <div v-if="displayErrors && Object.keys(errors).length > 0" class="form-error" v-text="Object.values(errors)[0]" />
    </slot>
    <div v-if="submitButton || otherButtons" class="btn-container">
      <Button v-if="submitButton" v-bind="submitButton" :loading="isSubmitting" :disabled="buttonIsDisabled(meta.valid)" :type="!buttonIsDisabled(meta.valid) && !isSubmitting ? 'submit' : 'button'" @click="state.isSubmit = true" />
      <Button v-for="button of otherButtons" v-bind="button"></Button>
    </div>
    <div v-if="otherButtons" class="btn-container">
    </div>
  </Form>
</template>

<script setup lang="ts">
import { Form } from "vee-validate";
import { reactive, computed } from "vue";
import Button from "./Button.vue";

const emits = defineEmits(["validForm"]);

const props = defineProps({
  submitButton: {
    type: Object,
  },
  otherButtons: {
    type: [Object],
  },
  callback: {
    type: Function,
    required: true,
  },
  clean: {
    type: Boolean,
    default: false,
  },
  displayErrors: {
    type: Boolean,
    default: true,
  },
  displayErrorsOnSubmit: {
    type: Boolean,
    default: false,
  },
  externalRule: {
    type: Boolean,
    default: true,
  },
  inline: {
    type: Boolean,
    default: false,
  },
});

const state = reactive({
  isSubmit: false,
});

const displaySlotError = computed(() => {
  if (props.displayErrorsOnSubmit) return state.isSubmit;

  return true;
});

function buttonIsDisabled(isValid) {
  if (props.submitButton.hotDisabled) {
    let invalidForm = !isValid || !props.externalRule;
    emits("validForm", !invalidForm);
    return invalidForm;
  }

  return false;
}
</script>
